import { createLifecycleFor } from 'actions/account/collections';
import { TYPE } from 'reducers/account/segmentMemberships';

export const SEGMENT_MEMBERSHIPS_RECALCULATED =
  'SEGMENT_MEMBERSHIPS_RECALCULATED';

export const { callApi, send, append, resolve, reject, patterns } =
  createLifecycleFor(TYPE);

export const recalculate = () => ({
  type: SEGMENT_MEMBERSHIPS_RECALCULATED,
});
